import React, { useState, useContext, useEffect } from 'react';
import { Radio, Col, Row } from 'antd';
import { DeleteFilled, BankOutlined, CreditCardOutlined } from '@ant-design/icons';
import Select from 'react-select';
import find from 'lodash/find';
import { DeclaredComponent } from '../../DynamicComponent';
import { PaymentDetailsContext } from './PaymentDetailsForm';
import { PaymentInfoContext } from '../../../context/PaymentInfoProvider';
import { FormContext } from '../../metadata/MDForm';
import { ModelContext } from '../../metadata/ModelSource';
import { getPaymentSources } from '../../../api/buyAPI';
import { navigateToHome } from '../../../navigation/navigationHistory';
import {env} from "../../../env";
import Button from "antd/lib/button";

const RadioButtons = ({ buttons }) => {
  return buttons.map((button, index) => {
    const buttonWidth = 100 / buttons.length;
    return (
      <Radio.Button
        style={{ width: `${buttonWidth}%` }}
        key={index}
        value={button.type}
        className="secondary-button"
      >
        <div style={{ textAlign: 'center' }}>{button.label}</div>
      </Radio.Button>
    );
  });
};

const AccountSelect = ({ id, component, options }) => {
  let { setValueByAttr, getValueByAttr } = useContext(FormContext);
  let typeSelection = options.filter(it=> it.value === getValueByAttr(id));
    typeSelection = typeSelection.length ? {value: typeSelection[0].value, label: typeSelection[0].name}: null;

  const typeChange = (selection) => {
    if (selection.value === 'Checking' || selection.value === 'Savings') {
      setValueByAttr('BankAccountType',selection.value);
    }
    if (selection.value === 'PPD' || selection.value === 'CCD') {
      setValueByAttr('AccountType',selection.value);
    }
  };

  const updatedOptions = options.map((option) => {
    return {
      value: option.value,
      label: option.name,
    };
  });

  return (
    <Select
      id={id}
      aria-label="Select"
      styles={customStyles}
      title="Select"
      openMenuOnFocus
      placeholder={null}
      options={updatedOptions}
      value={typeSelection}
      onChange={typeChange}
      components={{
        IndicatorSeparator: () => null,
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        zIndex: 3,
        colors: {
          ...theme.colors,
          primary25: 'rgb(0, 115, 157, 0.1)',
          primary: 'rgba(0, 115, 157, 0.5)',
          neutral30: 'rgba(0, 115, 157, 0.5)',
        },
      })}
    />
  );
};

export const SelectedMethod = ( {content}) => {

  const { getValueByAttr, setValueByAttr, setValue } = useContext(FormContext);
  const { ACHEnabled, currentPaymentSource, setCurrentPaymentSource } = useContext(PaymentInfoContext);
  const selection = getValueByAttr('PaymentMethod');
  const selectPaymentType = getValueByAttr('ExistCardId');
  const selectedGroup = find(content, selection);
  const { accountTypes, bankAccountTypes } = useContext(PaymentDetailsContext);

  useEffect(()=>{
    if (selection === 'ACH' && !ACHEnabled){
      //clear payment info and unselected the payment type
      setValueByAttr('CustomerPaymentProfileId','');
      setValueByAttr('CustomerProfileId', '');
      setValueByAttr('CreditCardNumber', '');
      setValueByAttr('CreditCardTypeCd', '');

      setValueByAttr('methodCd', '');
      setValueByAttr('achName', '');
      setValueByAttr('achBankName', '');
      setValueByAttr('achBankAccountTypeCd', '');
      setValueByAttr('achBankAccountNumber', '');
      setValueByAttr('achRoutingNumber', '');
      setValueByAttr('achStandardEntryClassCd', '');

      let paymentSources = currentPaymentSource.map(p=>({...p,isChecked:false}));
      setCurrentPaymentSource(paymentSources)
    }
  },[selection])

  if(!selection) return null;
  if (selectPaymentType !== 'NewCard') return null;

  if(selection === 'ACH' && !ACHEnabled){
    const types = [accountTypes, bankAccountTypes];
    const selectedContent  = selectedGroup[selection]["content"];

    return (
      <div style={{ marginTop: '30px' }}>
        <p>Bank Account Type</p>
        <div>
          <Row gutter={8} style={{ marginBottom: '30px' }}>
            <Col span={16}>
              <div style={{ display: 'flex' }}>
                {types.map((type, index) => {
                  return (
                    <div key={index} style={{ flex: 1 }}>
                      <AccountSelect
                          id={
                            index === 0
                                ? 'AccountType'
                                : 'BankAccountType'
                          }
                          key={index}
                          options={type}
                      />
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
          {selectedContent.map((component, index) => {
            if (
              component.Field &&
              component.Field.attr &&
              (component.Field.attr === 'BankAccountType' ||
                  component.Field.attr === 'AccountType')
            ) {
              return null;
            }
            return (
              <DeclaredComponent
                  aria-label="Input"
                  declaration={component}
                  key={index}
              />
            );
          })}
        </div>
      </div>
    );
  } else if (selection === 'CC' && !ACHEnabled){
    const selectedContent = selectedGroup[selection]["content"];
    const creditCardContent = selectedContent.map((component, index) => (
      <DeclaredComponent
        aria-label="Input"
        declaration={component}
        key={index}
      />
      ));
    return creditCardContent;
  } else {
    return null;
  }
};

export const PaymentMethodSelect = ({buttons, onChange}) => {
  const { ACHEnabled } = useContext(PaymentInfoContext);
  if (ACHEnabled){
    return null;
  }

  return (
      <div>
        <Radio.Group
          // defaultValue={'CC'}
          onChange={onChange}
          buttonStyle="solid"
        >
          <RadioButtons buttons={buttons}/>
        </Radio.Group>
      </div>
  )
};

export const PaymentType = () => {
  const { getValueByAttr, setValueByAttr, setValue, getValue, touch } = useContext(FormContext);
  const { ACHEnabled, currentPaymentSource, setCurrentPaymentSource, setExistCardId } = useContext(PaymentInfoContext);
  const [error, setError] = useState('');
  const existCardId = getValueByAttr('ExistCardId');

  const applicationModel = useContext(ModelContext);

  const convertPaymentSources = (data, isPriorPayment=false, isChecked)=>{
    if (!Array.isArray(data)) return;
    data = data.map(d=>({
      ...d,
      isPriorPayment,
      isChecked
    }))
    let paymentSources = currentPaymentSource.map(p=>({...p,isChecked:false}));
    if (isPriorPayment){
      // Prevent add duplicated prior payment into local payment sources
      let tmp = [...paymentSources];
      for (let d of data){
        if (paymentSources.find(p=>p.id === d.id)){
        }else {
          tmp.push(d);
        }
      }
      paymentSources = tmp;
    }else {
      paymentSources = [...paymentSources,...data];
    }

    paymentSources = paymentSources.map((p,i)=>({
      ...p,
      type: 'ExistCard'+i,
      label: p.methodCd === 'ACH' ? 'ACH Bank ' + p.achBankAccountNumber : `CC ${p.creditCardTypeCd} ${p.creditCardNumber}`,
    }))
    setCurrentPaymentSource(paymentSources)
  }

  useEffect(()=>{
    getPaymentSources(applicationModel.data.systemId).then(
        (res) => {
          convertPaymentSources(res.data.electronicPaymentSource);
        }
    ).catch(err => {
      const status = (err.response ? err.response.status : 500);
      if (status === 403) navigateToHome( );  // Permission denied suggests application-session ended
      throw (err);
    });
  },[]);

  const onPaymentTypeChange = (e)=> {
    const type = "NewCard";
    const existCard = currentPaymentSource.find(v => v.type === type);
    const path = 'basicPolicy.electronicPaymentSource';
    const electronicPaymentSource = applicationModel.getValue(path)
    let ePaymentSource = {...electronicPaymentSource,
      achBankAccountNumber:''};
    const selection = getValueByAttr('PaymentMethod');
    if (selection === 'ACH') {
      ePaymentSource = {...ePaymentSource,paymentMethod:''}
    }
    setValue('basicPolicy.electronicPaymentSource', {...ePaymentSource});
    touch('CreditCardNumber',false);
    setValueByAttr('ExistCardId', type);
    setExistCardId(type);
  }

  const onClickHandler = ()=>{
    const config = {
      'paymentConfigId': env.creditCardPaymentConfigId,
      'tenant': env.creditCardPaymentTenant,

      // OPTIONAL: should be omitted unless you need to test a pre-production api (local or staging)
      'apiUrl': env.creditCardPaymentApiUrl,

      // OPTIONAL: card description
      'cardDescription': '',

      // customer info needed for "Add CC" call
      // Many vendors require customer address information for address verification (AVS) and fraud detection
      'customerAddress': '',
      'customerCity': '',
      'customerCountry': '',
      'customerEmail': '',
      'customerFirstName': '',
      'customerLastName': '',
      'customerState': '',
      'customerZip': '',

      // 'customerAddress': '123 Main',
      // 'customerCity': 'Birmingham',
      // 'customerCountry': 'US',
      // 'customerEmail': 'john.smith+test@gmail.com',
      // 'customerFirstName': 'John',
      // 'customerLastName': 'Smith',
      // 'customerState': 'AL',
      // 'customerZip': '35203',
      // OPTIONAL: feature flags
      'featurePrefillAddress': true,
      'featureCustomAddressCollection': 'ONEINC',

      // OPTIONAL: ui customization

      'paymentCategory' : 'UserSelect', //Specific to One Inc. allow user to use CreditCard, ECheck, or UserSelect modal to display.
      // defaults to CreditCard if not set
      'uiAcceptJsButtonText': 'Save Card',
      'uiAcceptJsHeaderText': 'Card Information',
      'uiAcceptJsBillingAddressOptionsJson': '{"show":false, "required":false}',
      'uiSdkAddressButtonText': 'Continue',
      'uiSdkAddressHeaderText': 'Billing Address',
      'uiSdkBackgroundColor': 'rgba(0, 0, 0, 0.1)',
      'uiSdkCloseButtonAriaAndTitle': 'Close',
      'uiSdkCloseButtonStyles': '',
      'uiSdkHideLoader': false,
      'uiSdkLoaderText': 'Loading...',
      'uiSdkLoaderColor': '#434958',

      // OPTIONAL: vendor metadata
      'vendorMetadata': undefined,

      // OPTIONAL: skip adding a card to Midas to only use the JS SDK for PCI Offloading
      'skipAddCreditCardCall': false,

      // OPTIONAL: developer switches
      'dev_enableVerboseLogging': true
    };

    const sdk = GuidewirePayments.createSDK(config);

    // call `sdk.collectAndAssociateCard(callback)` when the user presses an "add CC" button
    sdk.collectAndAssociateCard(result => {
      switch (result.type) {
        case 'ERROR':
          // handle error, since error message from SDK is not user friendly and there is not error code from SDK,
          // so we use this one as general error message
          handlerError('The bank account information you entered is not valid.');
          break;
        case 'CARD_ADDED':
          let paymentInfo = {};
          if (result.card.sourceType === 'ACH'){
            paymentInfo = {
              ...result.card,
              methodCd:result.card.sourceType,
              achBankAccountNumber:result.tokenizedCard.lastFour,
              achBankName:result.card.financialInstitutionName,
              achName:result.card.nameOnAccount,
              standardEntryClassCd: result.tokenizedCard.standardEntryClassCode,
              customerPaymentProfileId:result.card.id.toString(),
              customerProfileId: result.card.id.toString()
            };
          }else {
            paymentInfo = {
              ...result.card,
              creditCardTypeCd:result.card.cardType,
              creditCardNumber:result.card.lastFour,
              expDate:result.card.expDate.substring(5)+'/'+result.card.expDate.substring(2,4),
              customerPaymentProfileId:result.card.id.toString(),
              customerProfileId: result.card.id.toString()
            };
          }

          console.log(paymentInfo)
          addPaymentSourceInfoToFormContext(paymentInfo);

          convertPaymentSources([paymentInfo],false,true)

          setValueByAttr('ExistCardId', "NewCard");
          setExistCardId("NewCard");
          setError('');
          break;
        case 'CANCELED':
          // user canceled
          break;
        case 'CARD_TOKENIZED':
          // only tokenize the card info
          break;
        default:
          console.warn('unexpected response type from payments sdk', result);
      }
    });
  }



  const addPaymentSourceInfoToFormContext = ({id, sourceType, achBankAccountNumber, accountType, methodCd, achBankName, achName, standardEntryClassCd, creditCardTypeCd, creditCardNumber})=>{
    setValueByAttr('CustomerPaymentProfileId', id.toString());
    setValueByAttr('CustomerProfileId', id.toString());
    if (sourceType === 'ACH'){
      applicationModel.setValue('basicPolicy.electronicPaymentSource.paymentServiceAccountId',getValue('basicPolicy.carrierCd'))
      applicationModel.setValue('basicPolicy.electronicPaymentSource.methodCd',`${methodCd}`)
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achName',`${achName}`)
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achBankName',`${achBankName}`)
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achBankAccountTypeCd',`${accountType}`)
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achBankAccountNumber',`${achBankAccountNumber}`)
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achRoutingNumber',`000000000`)
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achStandardEntryClassCd',`${standardEntryClassCd}`)

      applicationModel.setValue('basicPolicy.electronicPaymentSource.creditCardTypeCd','')
      applicationModel.setValue('basicPolicy.electronicPaymentSource.creditCardNumber','')
    }else {
      applicationModel.setValue('basicPolicy.electronicPaymentSource.methodCd','CC')
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achName','')
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achBankName','')
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achBankAccountTypeCd','')
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achBankAccountNumber','')
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achRoutingNumber','')
      applicationModel.setValue('basicPolicy.electronicPaymentSource.achStandardEntryClassCd','')

      applicationModel.setValue('basicPolicy.electronicPaymentSource.paymentServiceAccountId',getValue('basicPolicy.carrierCd'))
      applicationModel.setValue('basicPolicy.electronicPaymentSource.creditCardTypeCd',`${creditCardTypeCd}`)
      applicationModel.setValue('basicPolicy.electronicPaymentSource.creditCardNumber',`${creditCardNumber}`)
    }
  };

  const handlerError = (errorMsg='')=>{
    errorMsg && setError(errorMsg);
    setValueByAttr('methodCd', '');
    setValueByAttr('achName', '');
    setValueByAttr('achBankName', '');
    setValueByAttr('achBankAccountTypeCd', '');
    setValueByAttr('achBankAccountNumber', '');
    setValueByAttr('achRoutingNumber', '');
    setValueByAttr('achStandardEntryClassCd', '');
    setValueByAttr('CustomerPaymentProfileId', '');
    setValueByAttr('CustomerProfileId', '');

    setValueByAttr('creditCardTypeCd', '');
    setValueByAttr('creditCardNumber', '');
  }


  const onSelectPaymentSource = (e)=>{
    const type = e.target.value;
    // const existCard = typeButtons.find(v => v.type === type);
    const existCard = currentPaymentSource.find(v => v.type === type);
    if (type === "NewCard") {
      const path = 'basicPolicy.electronicPaymentSource';
      const electronicPaymentSource = applicationModel.getValue(path)
      let ePaymentSource = {...electronicPaymentSource,
        achBankAccountNumber:''};
      const selection = getValueByAttr('PaymentMethod');
      if (selection === 'ACH') {
        ePaymentSource = {...ePaymentSource,paymentMethod:''}
      }
      setValue('basicPolicy.electronicPaymentSource', {...ePaymentSource});
      touch('CreditCardNumber',false);
    }else {
      let paymentResource = getValueByAttr('paymentResource');
      if (!paymentResource){
        paymentResource = existCard;
      }
      setValue('basicPolicy.electronicPaymentSource', {...paymentResource,...existCard.paymentResource});
    }
    setValueByAttr('ExistCardId', existCard.type);
    setExistCardId(existCard.type);

    const paymentSources = currentPaymentSource.map(b=>({...b,isChecked : b.type === type}));
    setCurrentPaymentSource(paymentSources)
  }

  const onDeletePayment = (type)=>{
    const button = currentPaymentSource.find(b=>b.type === type);
    if (button.isChecked){
      setValue('basicPolicy.electronicPaymentSource', {});
    }

    let paymentSources = currentPaymentSource.filter(b=>b.type !== type);
    setCurrentPaymentSource(paymentSources)
  }
  return (
    <div>
      <Radios buttons={currentPaymentSource} onRadioClick={onSelectPaymentSource} onDeletePayment={onDeletePayment}/>
      <Button onClick={ACHEnabled ? onClickHandler : onPaymentTypeChange} type='primary' style={{marginTop:'20px'}}>
        {'Add New Payment Type'}
      </Button>

      <div style={{marginTop:'10px'}}>
        {error && getValue('basicPolicy.electronicPaymentSource.methodCd') ? <p style={{color:'red'}}>{error}</p> : null}
      </div>
    </div>
  )
};

const Radios = ({ buttons, onRadioClick, onDeletePayment }) => {
  const radioStyle = {
    // display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  const PaymentTypeIcon = ({type})=>{
    return type === 'ACH' ? <BankOutlined /> : <CreditCardOutlined/>
  }

  return buttons.map((button, index) => {
    return (
        <div>
          <Radio style={radioStyle} key={index} value={button.type} checked={button.isChecked} onClick={onRadioClick}>
            <PaymentTypeIcon type={button.methodCd} /> {button.label}
          </Radio>
          { !button.isPriorPayment ? <DeleteFilled style={{width:'25px',height:'25px'}} onClick={()=>onDeletePayment(button.type)}/> : null}
        </div>
    );
  })
};

const customStyles = {
  control: (base) => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};
